import { Component, Input } from "@angular/core";

@Component({
    selector: "app-simple-stepper",
    templateUrl: "./simple-stepper.component.html",
    styleUrls: ["./simple-stepper.component.scss"],
    standalone: false
})
export class SimpleStepperComponent {
  @Input() currentStep: number = 1;
  @Input() totalSteps: number = 3;

  private stepLabels = ["Choose Plan", "Billing Information", "Review & Pay"];

  get steps(): number[] {
    return Array.from({ length: this.totalSteps }, (_, i) => i + 1);
  }

  isCompleted(step: number): boolean {
    return step < this.currentStep;
  }

  isActive(step: number): boolean {
    return step === this.currentStep;
  }

  getStepLabel(step?: number): string {
    const stepIndex = (step || this.currentStep) - 1;
    return this.stepLabels[stepIndex] || "";
  }
}
